export const ATTRIBUTES = {
    DEFAULT_COUNTRY: 'default-country',
    NO_COUNTRY_CHANGE: 'no-country-change',
};

export const SESSION_STORAGE_KEY = 'masked_phone_country';
